var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer is-flex"},[_c('button',{staticClass:"App_open",on:{"click":_vm.appOpen}},[_vm._v("App内打开")])])
}
var staticRenderFns = []

export { render, staticRenderFns }